import { all, call, put, takeLatest } from "redux-saga/effects";
import { http } from "../../common/lib";
import { actionCreators, actionTypes } from "./actions";
import config from "../../config";
import { logToSentry } from "../../config/Sentry";

function* patch(action) {
    const { auditAssets } = action.payload;
    try {
        const { data } = yield call(
            http.authorized.post,
            config.api.paths.auditAssetBulkUpdate,
            auditAssets
        );
        yield put(actionCreators.patchSuccess(data));
    } catch (error) {
        logToSentry("On audit assets patch:", { error });
        yield put(actionCreators.patchFailure(error));
    }
}

function* post(action) {
    const { auditAssets } = action.payload;
    const url = config.api.paths.auditAssetBulkUpdate;
    try {
        const { data } = yield call(http.authorized.post, url, auditAssets);
        yield put(actionCreators.postSuccess(data));
    } catch (error) {
        console.error(error);
        logToSentry("On audit assets post:", { error });
        yield put(actionCreators.postFailure(error));
    }
}

export default function* () {
    yield all([
        takeLatest(actionTypes.AUDIT_ASSETS_PATCH_REQUEST, patch),
        takeLatest(actionTypes.AUDIT_ASSETS_POST_REQUEST, post)
    ]);
}
